import React, { useState } from "react";
import CouponCampaign from "../coupons-shared/coupon-campaign";
import PurchaseConfirmationModal from "../coupons/purchase-confirmation-modal";
import ModalPortal from "../shared/modal-portal";
import KyteTecModal from "../coupons/KyteTecModal";
import useMakeScrollable from "../../custom_hooks/make-scrollable";

const CouponCampaignList = ({ campaigns }) => {
  useMakeScrollable()
  const [showPurchaseModal, setShowPurchaseModal] = useState(false);
  const [selectedCampaignId, setSelectedCampaignId] = useState(null);
  const [showKyteTecModal, setShowKyteTecModal] = useState(false);
  const [selectedCouponCode, setSelectedCouponCode] = useState(null);
  const [
    showKyteTecRegistrationModal,
    setShowKyteTecRegistrationModal,
  ] = useState(false);
  const [selectedCampaignDiscount, setSelectedCampaigDiscount] = useState(0);

  const showPurchasedCouponCampaignModal = (campaignId, couponCode, discount) => {
    setSelectedCampaignId(campaignId);
    setSelectedCouponCode(couponCode);
    setSelectedCampaigDiscount(discount)
    setShowPurchaseModal(true);
    setShowKyteTecRegistrationModal(true);
  };
  
  return (
    <div className="scrollable">
      {campaigns.map((campaign) => (
        <CouponCampaign
          key={campaign.couponCode}
          campaign={campaign}
          onClick={() =>
            showPurchasedCouponCampaignModal(campaign.id, campaign.couponCode, campaign.discount)
          }
          showExpiresAt
        />
      ))}
      <ModalPortal>
      <div className="scrollable">
        {showPurchaseModal &&  (
          <PurchaseConfirmationModal
            campaignId={selectedCampaignId}
            setShowPurchaseModal={setShowPurchaseModal}
            setShowKyteTecModal={setShowKyteTecModal}
            couponCode={selectedCouponCode}
            discount={selectedCampaignDiscount}
            setShowKyteTecRegistrationModal={setShowKyteTecRegistrationModal}
            showKyteTecRegistrationModal={showKyteTecRegistrationModal}
          />
        )}
      </div>
      </ModalPortal>
      <ModalPortal>
      <div className="scrollable">
        {showKyteTecModal && selectedCouponCode && (
          <KyteTecModal
            couponCode={selectedCouponCode}
            campaignId={selectedCampaignId}
            setShowKyteTecModal={setShowKyteTecModal}
          />
        )}
      </div>
      </ModalPortal>
    </div>
  );
};
export default CouponCampaignList;
